<template>
  <div class="column sityscape__page" :dir="rightDir ? 'rtl' : 'ltr'">
    <div class="bg-header"/>
    <div class="container">
      <header class="sityscape__header">
        <div class="sityscape__header-title">
          <ui-link
            class="df-logo"
            :class="{'logo-right': direction.isRight}"
            :to="`/${locale}`"
            aria-label="Home"
          >
            <DFLogo color="var(--var-white-000)"/>
            <div class="title">
              {{ $t('DreamFlat') }}
            </div>
          </ui-link>
          <div class="cityscape-logo"/>
        </div>
        <nav class="sityscape__header-nav">
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToAnchor('#about')"
          >{{ $t('aboutDreamFlat') }}</a
          >
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToAnchor('#howTouse')"
          >{{ $t('howToUse') }}</a
          >
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToAnchor('#cases')"
          >{{ $t('cases') }}</a
          >
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToAnchor('#advantages')"
          >{{ $t('advantages') }}</a
          >
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToAnchor('#tariff')"
          >{{ $t('plans') }}</a
          >
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToAnchor('#investors')"
          >{{ $t('forInvestors') }}</a
          >
          <ui-fab
            class="change-lang"
            :options="listLang"
            :type="'light'"
            @select="onSelectLang"
            v-if="listLang.length > 1"
          >
            <IconLangWhite/>
          </ui-fab>
        </nav>
      </header>
      <header class="sityscape__mobile-header">
        <div class="sityscape__header-title">
          <div id="cityscape-sidemenu">
            <button
              class="sidemenu__btn"
              :class="[{active: navOpen}]"
              @click="
                () => {
                  changeLanguageInMobileModal
                    ? (changeLanguageInMobileModal =
                        !changeLanguageInMobileModal)
                    : (navOpen = !navOpen);
                }
              "
            >
              <template v-if="!changeLanguageInMobileModal">
                <span class="top"/>
                <span class="mid"/>
                <span class="bottom"/>
              </template>
              <template v-else>
                <IconArrowToTopGray class="mobile-lang-back"/>
              </template>
            </button>
            <transition name="translateX">
              <nav
                v-show="navOpen"
                :style="{
                  right: rightDir ? '0' : 'auto',
                  left: rightDir ? 'auto' : '0',
                }"
              >
                <div class="sidemenu-header-main">
                  <div
                    class="title-mobile-menu-block_logo"
                    :style="{
                      left: rightDir ? '10px' : 'auto',
                      right: rightDir ? 'auto' : '16px',
                    }"
                  >
                    <nuxt-link
                      v-if="!changeLanguageInMobileModal"
                      to="/cityscape"
                      class="city-logo"
                    >
                      <div class="city-logo-box">
                        <ui-link
                          class="df-logo"
                          :class="{'logo-right': direction.isRight}"
                          :to="`/${locale}`"
                          aria-label="Home"
                        >
                          <DFLogo color="var(--var-white-000)"/>
                          <div class="title">
                            {{ $t('DreamFlat') }}
                          </div>
                        </ui-link>
                      </div>
                      <div class="cityscape-logo"/>
                    </nuxt-link>
                    <nuxt-link v-else class="chooseYourLang">
                      {{ $t('choseLang') }}
                    </nuxt-link>
                  </div>
                </div>
                <div class="sidemenu__wrapper">
                  <ul
                    v-if="!changeLanguageInMobileModal"
                    class="sidemenu__list"
                    :class="{'menu-text-right': rightDir}"
                  >
                    <li class="sidemenu__item">
                      <nuxt-link
                        @click="navOpen = false"
                        @click.prevent="goToAnchor('#about')"
                      >
                        {{ $t('aboutDreamFlat') }}
                      </nuxt-link>
                    </li>
                    <li class="sidemenu__item">
                      <nuxt-link
                        @click="navOpen = false"
                        @click.prevent="goToAnchor('#howTouse')"
                      >
                        {{ $t('howToUse') }}
                      </nuxt-link>
                    </li>
                    <li class="sidemenu__item">
                      <nuxt-link
                        @click="navOpen = false"
                        @click.prevent="goToAnchor('#cases')"
                      >
                        {{ $t('cases') }}
                      </nuxt-link>
                    </li>
                    <li class="sidemenu__item">
                      <nuxt-link
                        @click="navOpen = false"
                        @click.prevent="goToAnchor('#advantages')"
                      >
                        {{ $t('advantages') }}
                      </nuxt-link>
                    </li>
                    <li class="sidemenu__item">
                      <nuxt-link
                        @click="navOpen = false"
                        @click.prevent="goToAnchor('#plans')"
                      >
                        {{ $t('plans') }}
                      </nuxt-link>
                    </li>
                    <li class="sidemenu__item">
                      <nuxt-link
                        @click="navOpen = false"
                        @click.prevent="goToAnchor('#investors')"
                      >
                        {{ $t('forInvestors') }}
                      </nuxt-link>
                    </li>
                    <li
                      class="sidemenu__item"
                      v-if="listLang.length > 1"
                    >
                      <nuxt-link
                        @click="changeLanguageInMobileModal = true"
                      >
                        <IconLangWhite/>
                      </nuxt-link>
                    </li>
                  </ul>
                  <ul
                    v-if="changeLanguageInMobileModal"
                    class="sidemenu__list"
                    :class="{'menu-text-right': rightDir}"
                  >
                    <li
                      v-for="lang in listLang"
                      :key="lang.value"
                      class="sidemenu__item"
                    >
                      <nuxt-link @click="onSelectLang(lang.value)">
                        {{ lang.label }}
                      </nuxt-link>
                    </li>
                  </ul>
                </div>
              </nav>
            </transition>
            <div
              v-if="navOpen"
              class="background-opacity"
              @click="navOpen = false"
            />
          </div>
          <div class="df">
            <ui-link
              class="df-logo"
              :class="{'logo-right': direction.isRight}"
              :to="`/${locale}`"
              aria-label="Home"
            >
              <DFLogo color="var(--var-white-000)"/>
              <div class="title">
                {{ $t('DreamFlat') }}
              </div>
            </ui-link>
          </div>
          <div class="cityscape-logo"/>
        </div>
      </header>
      <section id="about" class="cityscape-section">
        <CityscapeAboutDF/>
      </section>
    </div>
    <div class="container">
      <section
        id="howTouse"
        class="cityscape-section mt84 mt-128 p-0"
      >
        <div
          class="cityscape-section__title"
          :dir="rightDir ? 'rtl' : 'ltr'"
        >
          {{ $t('whoUses') }}
        </div>
        <CityscapeHowToUse/>
      </section>
    </div>

    <div class="container mt-128">
      <div
        id="cases"
        class="cityscape-section-wide__title mt-128"
        :dir="rightDir ? 'rtl' : 'ltr'"
      >
        {{ $t('getAmazed') }} <br/>
        {{ $t('ofVisualizations') }}
      </div>
      <div
        class="cityscape-section-wide__subtitle"
        :dir="rightDir ? 'rtl' : 'ltr'"
      >
        {{ $t('getInspired') }}
      </div>
      <CityscapeCases/>
    </div>

    <div class="container">
      <section id="advantages" class="cityscape-section">
        <div
          class="cityscape-section__title"
          :dir="rightDir ? 'rtl' : 'ltr'"
        >
          {{ $t('seeAdvantages') }}<br/>
          <span class="small">{{ $t('maximize') }}</span>
        </div>
        <CityscapeAdvantages/>
      </section>
      <section id="tariff" class="cityscape-section mt-128 p-0">
        <CityscapeTariffs style="margin-top: 0"/>
        <UiTariffsInfo
          color="#6B4DFF"
        />
      </section>

    </div>
    <section id="investors" class="cityscape-section">
      <ForInvestorsComponent id="investors" email-subject="CityScape Investment"/>
    </section>
    <div class="bg-footer-info">
      <div
        class="container bg-footer-info-box"
        :class="{'row-reverse': rightDir}"
      >
        <div class="mail">hello@dreamflat.design</div>
        <div class="links">
          <a
            v-if="!isDflat"
            href="https://www.instagram.com/dreamflat.design/"
            target="_blank"
          >
            <div class="inst icon"/>
          </a>
          <a
            v-if="!isDflat"
            href="https://www.facebook.com/profile.php?id=100090565989165"
            target="_blank"
          >
            <div class="facebook icon"/>
          </a>
          <a
            v-if="!isDflat"
            href="https://www.linkedin.com/company/93650643/"
            target="_blank"
          >
            <div class="linkedIn icon"/>
          </a>
        </div>
      </div>
    </div>
  </div>
  <ModulesUserLogin
    :show="showLoginModal"
    @update:show="
      $event ? user.showLoginModal() : user.hideLoginModal()
    "
    @hide="user.hideLoginModal"
  />
</template>

<script lang="ts" setup>
import {computed, ref} from 'vue';
import CityscapeAboutDF from '~/modules/CityScape/components/CityscapeAboutDF.vue';
import CityscapeHowToUse from '~/modules/CityScape/components/CityscapeHowToUse.vue';
import CityscapeCases from '~/modules/CityScape/components/CityscapeCases.vue';
import CityscapeAdvantages from '~/modules/CityScape/components/CityscapeAdvantages.vue';
import IconLangWhite from '~/assets/svg/lang-white.svg';
import IconArrowToTopGray from '~/assets/svg/arrowtotopgray.svg';
import {useI18n} from 'vue-i18n';
import {useBaseStore} from '~/modules/BaseModule/base.store';
import {useDirectionStore} from '~/store/direction.store';
import {useUserStore} from '~/modules/User/user.store';
import {useLauncherInfoStore} from '~/store/launcher-info';
import {useRuntimeConfig} from '#imports';

definePageMeta({
  layout: false,
});

const {locale, t} = useI18n();

useHead({
  title: 'DreamFlat — CityScape',
  meta: [
    {
      name: 'description',
      content: `${t('gitexHeroDes')}`,
    },
  ],
});

const direction = useDirectionStore();
const user = useUserStore();
const launcherInfo = useLauncherInfoStore();
const rightDir = computed(() => direction.isRight);
const showLoginModal = computed(() => user.isShowLoginModal);
const userInfo = ref({username: ''});

const base = useBaseStore();

const runtimeConfig = useRuntimeConfig();
const isDflat = runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru');

const changeLanguageInMobileModal = ref(false);

function goToAnchor(id: string) {
  document
    .querySelector(id)
    ?.scrollIntoView({behavior: 'smooth', block: 'start'});
}

const navOpen = ref(false);

function onSelectLang(event: any) {
  locale.value = event;
}

const listLang = base.listLangCurrent;

user.$subscribe((_, state) => {
  if (!state.error) {
    if (state.isLoggedIn) {
      user.hideLoginModal();
    }
    // user.isLoggedIn = true
    userInfo.value = state;
  }
});

onBeforeMount(async () => {
  const f = async () => await launcherInfo.update();
  await f();
});
</script>
<style scoped lang="scss">
.sityscape__page {
  .df-logo {
    display: flex;
    color: white;
    align-items: center;
    gap: $g-3;

    svg {
      height: 36px;
      width: 56px;
    }

    .title {
      @include headline-h3;
      color: var(--var-white-000);
      font-weight: $fw-600;
    }

    @media (max-width: $md) {
      gap: $g-2;
      svg {
        height: 18px;
        width: 38px;
      }

      .title {
        font-size: $fs-14;
      }
    }
  }

  .df {
    .df-logo {
      svg {
        height: 25px;
        width: 45px;
      }
    }

    @media (max-width: $md) {
      .df-logo {
        svg {
          height: 20px;
          width: 40px;
        }
      }
    }
  }
}

.flex-right {
  flex-direction: row-reverse;
  justify-content: space-between;
}

.menu-text-right {
  text-align: right;
}

.sityscape {
  &__page {
    // padding-top: 96px;
    position: relative;

    .bg-header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 588px;
      background: #0d0c33;
      z-index: -1;
    }

    .bg-footer {
      position: absolute;
      right: 0;
      left: 0;
      bottom: 56px;
      height: 813px;
      background: #0d0c33;
      z-index: -1;
    }

    .bg-footer-info {
      height: 56px;
      background: #08081e;
      align-items: center;

      &-box {
        margin: 0 auto;
        max-width: 1128px;
        width: 100%;
        height: 100%;
        padding: 16px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &.row-reverse {
          flex-direction: row-reverse;
        }

        .mail {
          color: var(--white-theme-white-400, #e1e5f0);
          font-family: Segoe UI;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%; /* 22.4px */
          letter-spacing: 0.48px;
        }

        .links {
          display: flex;
          gap: 8px;
          width: auto;
          height: 24px;

          .icon {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }

          .inst {
            background-image: url(assets/cityscape/InstagramLogo.svg);
          }

          .facebook {
            background-image: url(assets/cityscape/cityscape-facebook.svg);
          }

          .linkedIn {
            background-image: url(assets/cityscape/cityscape-linkedin.svg);
          }
        }
      }
    }

    @media (max-width: $lg) {
      padding-top: 0;
    }

    .figures-sections {
      margin: 0 auto;
      position: relative;
      padding: 96px 0;
      width: 100%;
      background: var(--white-theme-white-200, #f6f8fd);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 32px;

      .square {
        position: absolute;
        right: -170px;
        top: 0;
        width: 556px;
        height: 556px;
        background-image: url(assets/cityscape/cityscape-square.svg);
        background-repeat: no-repeat;
      }

      .triangle {
        position: absolute;
        left: 0;
        top: 45%;
        width: 597px;
        height: 597px;
        background-image: url(assets/cityscape/cityscape-triangle.svg);
        background-repeat: no-repeat;
      }

      &__title {
        text-align: center;
        color: var(--white-theme-black-100, #3d424a);
        font-family: Segoe UI;
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 1.08px;
        z-index: 1;

        & > span {
          color: #6b4dff;
          text-align: center;
        }
      }
    }

    .cityscape-section-wide__title {
      margin: 0 auto 16px;
      color: var(--white-theme-black-100, #3d424a);
      text-align: center;
      font-family: Segoe UI;
      font-size: 36px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 43.2px */
      letter-spacing: 1.08px;
    }

    .cityscape-section-wide__subtitle {
      margin: 0 auto 40px;
      color: var(--white-theme-black-200, #64686e);
      text-align: center;
      font-family: Segoe UI;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 22.4px */
      letter-spacing: 0.48px;
    }

    .container {
      max-width: 1128px;
      margin: 0 auto !important;

      .sityscape__mobile-header {
        display: none;
      }

      .sityscape__header {
        width: 100%;
        height: 96px;
        padding-top: 24px;
        padding-bottom: 8px;
        display: flex;
        justify-content: space-between;

        &-title {
          height: 64px;
          width: 354px;
          display: flex;

          .df-name {
            height: 32px;
            align-self: center;
            margin-left: 8px;
            color: #fff;
            text-align: center;
            font-family: Segoe UI;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            letter-spacing: 0.48px;
          }

          .cityscape-logo {
            margin-left: 32px;
            height: 64px;
            width: 133px;
            background-image: url(assets/cityscape/cityscape-logo.svg);
          }
        }

        &-nav {
          // margin-left: auto;
          align-self: center;
          height: 19px;
          min-width: 546px;
          display: flex;
          justify-content: space-between;
          gap: $g-3;

          .nav-link {
            text-decoration: none;
            color: #fff;
            text-align: center;
            font-family: Segoe UI;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            letter-spacing: 0.28px;
            cursor: pointer;
          }
        }
      }

      .mt84 {
        margin-top: 84px;
      }

      .mb56 {
        margin-bottom: 56px;
      }

      .cityscape-section {
        width: 100%;
        padding-top: 96px;
        padding-bottom: 96px;

        &__title {
          margin-bottom: 40px;
          text-align: center;
          color: var(--white-theme-black-100, #3d424a);
          font-family: Segoe UI;
          font-size: 36px;
          font-style: normal;
          font-weight: 700;
          line-height: 120%; /* 43.2px */
          letter-spacing: 1.08px;

          .small {
            color: var(--white-theme-black-200, #64686e);
            text-align: center;
            font-family: Segoe UI;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%; /* 22.4px */
            letter-spacing: 0.48px;
          }

          & > span {
            color: #6b4dff;
            text-align: center;
          }
        }
      }

      @media (max-width: 1160px) {
        max-width: 1024px;
      }
      @media (max-width: $lg) {
        max-width: 100%;
        padding: 0px 16px;
      }
    }

    .report {
      // max-width: 1920px;
      width: 100%;
      margin: 0 auto;
      overflow-x: hidden;
      @media (max-width: 1160px) {
        max-width: 1024px;
      }
      @media (max-width: $lg) {
        max-width: 100%;
        padding: 0px 16px;
      }
    }
  }

  &__section {
    &-title {
      font-weight: 700;
      font-size: 36px;
      line-height: 120%;
      letter-spacing: 0.03em;
      color: #3d424a;
      margin-bottom: 40px;
      @media (max-width: $lg) {
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0.03em;
        margin-bottom: 32px;
        br {
          display: none;
        }
      }
    }
  }

  &__section + &__section--small-mt {
    margin-top: 96px;
    @media (max-width: $lg) {
      margin-top: 128px;
    }
  }
}

@media screen and (max-width: 1000px) {
  .chooseYourLang {
    user-select: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.32px;
    text-decoration: none;
    color: #fff;
    display: block;
    padding: 14px 0;
  }
  .mobile-lang-back {
    rotate: -90deg;
  }

  .sityscape__page {
    .container {
      overflow: hidden;
      align-items: center;

      .sityscape__header {
        display: none;
      }

      .sityscape__mobile-header {
        display: block;

        .sityscape__header-title {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .df {
            display: flex;
          }
        }
      }

      .p-0 {
        padding: 0;
      }

      .mt-128 {
        margin-top: 128px;

        @media (max-width: $md) {
          margin-top: $m-30;
        }
      }
    }

    .bg-header {
      height: 1121px;
    }

    .bg-footer {
      height: 1495px;
    }

    .bg-footer-info {
      padding: 16px;
      height: auto;

      .bg-footer-info-box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        padding: 0;

        &.row-reverse {
          flex-direction: column;
        }

        .links {
          width: auto;
          gap: 24px;
        }
      }
    }

    #cases {
      display: block;
      margin-top: 128px;
    }

    #advantages {
      padding-top: 31px;
      padding-bottom: 0;
    }

    .figures-sections {
      overflow: hidden;

      .cityscape-btn {
        z-index: 1;
      }

      .triangle {
        width: 300px;
        height: 300px;
        top: 240px;
        left: -200px;
      }

      .square {
        width: 232px;
        height: 232px;
        // transform: rotate(133deg);
        // top: 40px;
        transform: rotate(107deg);
        top: -120px;
        right: -160px;
        border-radius: 16px;
      }
    }
  }
  #cityscape-sidemenu {
    display: block;

    nav {
      width: 300px;
      height: 100%;
      background: #0d0c33;
      position: fixed;
      top: 0;
      // left: 0;
      z-index: 9999;
      overflow-y: scroll;

      .title-mobile-menu-block_logo {
        position: absolute;
        // right: 16px;
        top: 12px;

        .city-logo {
          width: 100%;
          display: flex;
          gap: 16px;

          .city-logo-box {
            display: flex;
            gap: 5px;
            align-items: center;

            .mobile-menu-title {
              color: #fff;
              font-weight: 600;
              font-size: 15px;
            }
          }

          .cityscape-logo {
            width: 83.462px;
            height: 40px;
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: 0;
          }
        }
      }
    }

    .background-opacity {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(32, 48, 64, 0.75);
      display: block;
      z-index: 98;
    }

    .sidemenu {
      &__wrapper {
        padding-top: 70px;
      }

      &__list {
        list-style: none;
        padding: 0 16px 0 16px;
        margin: 0;
      }

      &__item {
        margin-bottom: 8px;

        a {
          user-select: none;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 16px; /* 100% */
          letter-spacing: 0.32px;
          text-decoration: none;
          color: #fff;
          display: block;
          transition: 0.4s ease;
          padding: 14px 0;
          cursor: pointer;

          &:hover {
            color: #fff;
            background-color: inherit;
          }
        }
      }
    }

    .translateX-enter {
      transform: translateX(-200px);
      opacity: 0;
    }

    .translateX-enter-active,
    .translateX-leave-active {
      transform-origin: top left 0;
      transition: 0.2s ease;
    }

    .translateX-leave-to {
      transform: translateX(-200px);
      opacity: 0;
    }
  }
  #cityscape-sidemenu {
    display: block;

    .sidemenu {
      &__btn {
        display: block;
        width: 44px;
        height: 44px;
        background: inherit;
        border: none;
        position: relative;
        z-index: 10000;
        appearance: none;
        cursor: pointer;
        outline: none;

        span {
          display: block;
          background: #ffffff;
          width: 20px;
          height: 2px;
          margin: auto;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          transition: all 0.4s ease;

          &.top {
            width: 10px;
            right: 10px;
            transform: translateY(-8px);
          }

          &.bottom {
            width: 10px;
            left: 10px;
            transform: translateY(8px);
          }
        }

        &.active {
          //.sidemenu__btn {
          span {
            background: #839aaf !important;
            //}
          }

          .top {
            width: 20px;
            right: 0;
            transform: rotate(-45deg);
          }

          .mid {
            transform: translateX(-20px) rotate(360deg);
            opacity: 0;
          }

          .bottom {
            width: 20px;
            left: 0;
            transform: rotate(45deg);
          }
        }

        &.white {
          span {
            background: #ffffff;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .sityscape__page {
    .bg-header {
      height: 1000px;
    }
  }
}

@media screen and (max-width: 750px) {
  .sityscape__page {
    .bg-header {
      height: 900px;
    }
  }
}

@media screen and (max-width: 450px) {
  .sityscape__page {
    .bg-header {
      height: 750px !important;
    }
  }
}

@media screen and (max-width: 600px) {
  .sityscape__page {
    .bg-header {
      height: 800px;
    }

    .container {
      .sityscape__mobile-header {
        .df {
          align-items: center;

          .df-name {
            font-size: 16.5px;
            vertical-align: middle;
            height: 100%;
          }
        }

        .cityscape-logo {
          width: 91px;
          height: 44px;
          margin-left: 0;
          background-size: contain;
        }
      }
    }

    .figures-sections {
      padding: 80px 0;

      &__title {
        font-size: 24px;
      }

      .cityscape-btn {
        font-size: 15px;
        padding: 12px 32px;
        height: auto;
        z-index: 1;
      }

      .square {
        width: 232px;
        height: 232px;
        // transform: rotate(133deg);
        // top: 40px;
        transform: rotate(107deg);
        top: -120px;
        right: -160px;
        border-radius: 16px;
      }

      .triangle {
        width: 300px;
        height: 300px;
        top: 240px;
        left: -200px;
      }
    }

    .cityscape-section {
      .cityscape-section__title {
        font-size: 24px !important;

        .small {
          font-size: 15px;
        }
      }
    }

    .cityscape-section-wide__title {
      font-size: 24px;
    }

    .cityscape-section-wide__subtitle {
      font-size: 15px;
      margin-bottom: 32px;
    }

    .bg-footer {
      height: 1500px;
    }

    .bg-footer-info {
      .bg-footer-info-box {
        .links {
          width: auto;
          gap: 24px;
        }
      }
    }

    #about {
      padding: 40px 0;
    }
  }
}

#investors {
  background-color: var(--var-blue-800);
  padding: $p-24 $p-0;

  @media (max-width: $lg) {
    padding: $p-10 $p-0;
  }
}
</style>
